import axios from "axios";
import { getToken} from "../Common";
import {addMenuMapping, menuGrpMapping, menuMapping, optionGrpMapping, shopMapping} from "./mappingService";
import { ORDER_PROXY_API, ORDER_API, POS_API, BACK_OFFICE_API } from "constants/apiUrls";


// 메뉴 그룹 조회
export const menuGrpList = async (shopId) => {
  try {
    if(shopId) {
      const response = await axios.get(`${ORDER_API}/menu/group/ceo`, {
        params: {
          shopId: shopId
        },
        headers: {Authorization: `Bearer ceo-${shopId}`}
      });
      return response.data;
    }
  } catch (error) {
    console.log(error);
  }
}

// 메뉴 그룹 상세 조회
export const menuGrpDetail = async (shopId, menuGrpId) => {
  try {
    if(menuGrpId) {
      const response = await axios.get(`${ORDER_API}/menu/group/ceo/${menuGrpId}`, {
        headers: {Authorization: `Bearer ceo-${shopId}`}
      });
      return response.data;
    }
  } catch (error) {
    console.log(error);
  }
}

// 메뉴 그룹 등록
export const addMenuGrp = async (shopId, data) => {
  let posShopId = await shopMapping(shopId);

  axios.post(`${ORDER_API}/menu/v2/group`, data).then((response) => {
    let menuGrpId = response.data.addMenuGroupIdList[0];

    axios.post(`${POS_API}/product/v2/group`, {
      modifierId: posShopId,
      modifierType: 1,
      shopId: posShopId,
      groupName: data.addMenuGroupList[0].name,
      description: data.addMenuGroupList[0].desc,
      exposureSequence: data.addMenuGroupList[0].visibleIndex,
      exposureStatus: Number(data.addMenuGroupList[0].isVisible)
    }).then(function(response) {
      let posMenuGrpId = response.data.productGroupId;

      axios.post(`${ORDER_PROXY_API}/product/v2/mapping/group/code`, {
        channelType: 2,
        data: [{
          posProductGroupId: Number(posMenuGrpId),
          orderProductGroupId: String(menuGrpId)
        }]
      }).then(function() {
        window.location.reload();
      })
    });
  });
}

// 메뉴 그룹 수정
export const menuGrpModify = async (shopId, menuGrpId, data) => {
  let posShopId = await shopMapping(shopId);
  let posMenuGrpId = await menuGrpMapping(menuGrpId);

  axios.post(`${ORDER_API}/menu/v2/group`, {
    shopId: shopId,
    setMenuGroupList: [data]
  }).then(() => {
    axios.put(`${POS_API}/product/v2/group`, {
      modifierId: posShopId,
      modifierType: 1,
      productGroupId: posMenuGrpId,
      groupName: data.name,
      description: data.desc,
      exposureStatus: Number(data.isVisible),
    }).then(function() {
      window.location.reload();
    });
  });
}

// 메뉴 그룹 순서 변경
export const menuGrpListChange = async (shopId, data) => {
  let posShopId = await shopMapping(shopId);

  axios.post(`${ORDER_API}/menu/v2/group`, {
    shopId: shopId,
    setMenuGroupList: data
  }).then(() => {
    data.forEach(async (value) => {
      let posMenuGrpId = await menuGrpMapping(value.menuGroupId);
      await axios.put(`${POS_API}/product/v2/group`, {
        modifierId: posShopId,
        modifierType: 1,
        productGroupId: posMenuGrpId,
        exposureSequence: value.visibleIndex
      })
    })

    window.location.reload();
  })
}

// 메뉴 그룹 상태 변경
export const menuGrpStatusChange = async (shopId, menuGrpId, status) => {
  let posShopId = await shopMapping(shopId);
  let posMenuGrpId = await menuGrpMapping(menuGrpId);

  axios.post(`${ORDER_API}/menu/v2/group`, {
    shopId: shopId,
    setMenuGroupList: [{
      menuGroupId: menuGrpId,
      isVisible: !status
    }]
  }).then(() => {
    axios.put(`${POS_API}/product/v2/group`, {
      modifierId: posShopId,
      modifierType: 1,
      productGroupId: posMenuGrpId,
      exposureStatus: Number(!status)
    }).then(function() {
      sessionStorage.setItem("targetId", `menuListBox${menuGrpId}`);
      window.location.reload();
    });
  });
}

// 메뉴 상태 변경
export const menuStatusChange = async (shopId, menuGrpId, menuId, status) => {
  let posShopId = await shopMapping(shopId);
  let posMenuId = await menuMapping(menuId);

  // 주문 채널 메뉴 수정
  axios.post(`${ORDER_API}/menu/v2`, {
    shopId: shopId,
    menuGroupId: menuGrpId,
    setMenuList: [{
      menuId: menuId,
      status: status
    }]
  }).then(() => {
    axios.put(`${POS_API}/product/v2`, {
      modifierId: posShopId,
      modifierType: 1,
      productId: posMenuId,
      productStatus: status
    }).catch((e) => {
      console.log(e);
    })
  }).catch((e) => {
    console.log(e);
  })
}

// 메뉴 상세 조회
export const getMenuDetail = async (menuId) => {
  let token = getToken();

  let menuDetail = await axios.get(`${ORDER_API}/menu/ceo/${menuId}`, {
    headers: {Authorization: `Bearer ${token}`}
  })

  return menuDetail.data;
}

// 메뉴 상세 조회2
export const getMenuDetail2 = async (menuId) => {
  let menuDetail = await axios.get(`${BACK_OFFICE_API}/menu/${menuId}`);

  return menuDetail.data[0];
}

export const getMenuImage = async (menuId, type) => {
  let data = await axios.get(`${BACK_OFFICE_API}/menu/img`, {
    params: {
      id: menuId,
      type: type
    }
  });

  return data.data;
}

// 메뉴 등록
export const newMenu = async (shopId, menuGrpId, data, priceData, optionData) => {
  let posShopId = await shopMapping(shopId);
  let posMenuGrpId = await menuGrpMapping(menuGrpId);
  let posData = {
    productGroupId: Number(posMenuGrpId),
    productType: 1,
    productStatus: Number(data.status),
    productName: data.name,
    organization: data.struct,
    description: data.desc,
    exposureSequence: data.visibleIndex,
    exposureStatus: Number(data.isVisible),
    adultStatus: Number(data.isAdultMenu)
  }
  let posPriceData = [];
  priceData.forEach(({name, cost}) => {
    posPriceData.push({
      productCostName: name,
      productCost: cost
    })
  })

  // 매뉴 등록
  const orderMenuId = await orderAddMenu(shopId, menuGrpId, data);
  const posMenuId = await posAddMenu(posShopId, posData);
  await addMenuMapping(orderMenuId, posMenuId);

  // 메뉴 가격 등록
  await orderAddPrice(orderMenuId, priceData);
  await posAddPrice(posShopId, posMenuId, posPriceData);

  // 메뉴 옵션 등록
  if (optionData.length > 0) {
    const posOptionData = await Promise.all(
      optionData.map(async (value) => {
        const posOptionId = await optionGrpMapping(value);
        return {
          productId: posOptionId,
          productOptionGroupId: value
        };
      })
    );

    await orderOptionMapping(orderMenuId, optionData, []);
    await posOptionMapping(posShopId, posOptionData);
  }

  window.location.reload();
}

// 메뉴 수정
export const setMenu = async (
  shopId, menuGrpId, menuId, data, adminData,
  priceList, setPriceList, removePriceList,
  optionList, removeOptionList
) => {
  let posShopId = await shopMapping(shopId);
  let posMenuGrpId = await menuGrpMapping(menuGrpId);
  let posMenuId = await menuMapping(menuId);
  let posMenuData = await posGetMenu(posMenuId);
  let posPriceList = posMenuData.productCostList
  let orderAddPriceList = [];
  let orderSetPriceList = [];
  let orderRemovePriceList = [];
  let posAddPriceList = [];
  let posSetPriceList = [];
  let posRemovePriceList = "";


  // 가격 데이터 변경
  if(priceList.length > 0) {
    priceList.forEach(({name, cost, saleCost}) => {
      posAddPriceList.push({
        productCostName: name,
        productCost: Number(cost)
      });
      orderAddPriceList.push({
        name: name,
        cost: cost,
        saleCost: saleCost
      });
    });
  }
  if(setPriceList.length > 0) {
    setPriceList.forEach(({menuCostId, name, cost, saleCost, number}) => {
      /*posAddPriceList.push({
        productCostName: name,
        productCost: Number(cost)
      });*/
      posSetPriceList.push({
        productCostId: posPriceList[number].id,
        productCostName: name,
        productCost: Number(cost)
      });
      orderSetPriceList.push({
        menuCostId: menuCostId,
        name: name,
        cost: cost,
        saleCost: saleCost
      });
    });
  }
  if(removePriceList.length > 0) {
    removePriceList.forEach(({id, number}) => {
      posRemovePriceList += `${posPriceList[number].id},`;
      orderRemovePriceList.push(id);
    });
    posRemovePriceList = posRemovePriceList.slice(0, -1);
  }

  let posData = {
    modifierId: posShopId,
    modifierType: 1,
    productId: posMenuId,
    productGroupId: posMenuGrpId,
    productStatus: data.status,
    productName: data.name,
    organization: data.menuInfo,
    description: data.menuDesc,
    exposureStatus: Number(data.isVisible),
    adultStatus: Number(data.isAdultMenu),
  }

  await adminSetMenu(menuId, adminData);
  await posSetMenu(posData);
  await orderSetMenu(shopId, menuGrpId, data);

  if(priceList.length > 0) {
    await orderAddPrice(menuId, orderAddPriceList);
    await posAddPrice(posShopId, posMenuId, posAddPriceList);
  }
  if(setPriceList.length > 0) {
    await orderSetPrice(menuId, orderSetPriceList, orderRemovePriceList);
    await posSetPrice(posShopId, posSetPriceList);
    //await posAddPrice(posShopId, posMenuId, posAddPriceList);
  }
  if(removePriceList.length > 0) {
    await posRemovePrice(posShopId, posRemovePriceList);
  }

  await orderOptionMapping(menuId, optionList, removeOptionList);

  // 옵션 데이터 변경
  if (optionList.length > 0) {
    const posOptionData = await Promise.all(
      optionList.map(async (value) => {
        const posOptionId = await optionGrpMapping(value);
        return {
          productId: posOptionId,
          productOptionGroupId: value
        };
      })
    );

    await posOptionMapping(posShopId, posOptionData);
  }

  if(removeOptionList.length > 0) {
    let posRemoveOptionList = "";
    const posOptionData = await Promise.all(
      removeOptionList.map(async (value) => {
        return await optionGrpMapping(value);
      })
    );

    posOptionData.forEach((value) => {
      posRemoveOptionList += `${value},`;
    });
    posRemoveOptionList = posRemoveOptionList.slice(0, -1);

    await posRemoveOptionMapping(posShopId, posMenuId, posRemoveOptionList);
  }


  window.location.reload();
}

export const posGetMenu = async (menuId) => {
  let menuData = await axios.get(`${POS_API}/product/v2/${menuId}`);

  return menuData.data;
}

export const orderAddMenu = async (shopId, grpId, data) => {
  let menuId = await axios.post(`${ORDER_API}/menu/v2`, {
    shopId: shopId,
    menuGroupId: grpId,
    addMenuList: [data]
  });

  return menuId.data.addMenuIdList[0].menuId;
}

export const orderSetMenu = async (shopId, grpId, data) => {
  await axios.post(`${ORDER_API}/menu/v2`, {
    shopId: shopId,
    menuGroupId: grpId,
    setMenuList: [data]
  })
}

export const posAddMenu = async (shopId, data) => {
  let menuId = await axios.post(`${POS_API}/product/v2`, {
    modifierId: shopId,
    modifierType: 1,
    channelType: 2,
    shopId: shopId,
    mappingStatus: 0,
    productItemList: [data]
  });

  return menuId.data.productIdList[0];
}

export const posSetMenu = async (data) => {
  await axios.put(`${POS_API}/product/v2`, data).catch((e) => console.log(e));
}

export const adminSetMenu = async (menuId, data) => {
  await axios.put(`${BACK_OFFICE_API}/menu/${menuId}`, data);
}

export const orderAddPrice = async (menuId, data) => {
  await axios.post(`${ORDER_API}/cost/menu`, {
    menuId: menuId,
    addMenuCostList: data
  });
}

export const orderSetPrice = async (menuId, setList, removeList) => {
  await axios.post(`${ORDER_API}/cost/menu`, {
    menuId: menuId,
    setMenuCostList: setList,
    removeMenuCostIdList: removeList
  })
}

export const posAddPrice = async (shopId, menuId, data) => {
  await axios.post(`${POS_API}/product/v2/cost`, {
    modifierId: shopId,
    modifierType: 1,
    productId: menuId,
    data: data
  })
}

export const posSetPrice = async (shopId, data) => {
  await axios.put(`${POS_API}/product/v2/cost`, {
    modifierId: shopId,
    modifierType: 1,
    data: data
  })
}

export const posRemovePrice = async (shopId, data) => {
  await axios.delete(`${POS_API}/product/v2/cost`, {
    params: {
      modifierId: shopId,
      modifierType: 1,
      productCostIdList: data
    }
  });
}

export const orderOptionMapping = async (menuId, addList, removeList) => {
  await axios.post(`${ORDER_API}/menu/v2/option/group/mapping`, {
    menuId: menuId,
    addOptionGroupIdList: addList,
    removeOptionGroupIdList: removeList
  });
}

export const posOptionMapping = async (shopId, data) => {
  await axios.post(`${POS_API}/product/v2/option-group/mapping`, {
    modifierId: shopId,
    modifierType: 1,
    data: data
  })
}

export const posRemoveOptionMapping = async (shopId, menuId, data) => {
  await axios.delete(`${POS_API}/product/v2/option-group/mapping`, {
    params: {
      modifierId: shopId,
      modifierType: 1,
      productId: menuId,
      optionGroupMappingIdList: data
    }
  })
}

// 메뉴 순서 변경
export const menuListChange = async (shopId, menuGrp, data) => {
  const posShopId = await shopMapping(shopId);
  console.log(data);
  if (data.length > 0) {
    await Promise.all(
      data.map(async (value, index) => {
        const posMenuId = await menuMapping(value.menuId);

        await axios.post(`${ORDER_API}/menu/v2`, {
          shopId: shopId,
          menuGrp: menuGrp,
          setMenuList: [{
            menuId: value.menuId,
            status: value.menuStatus,
            visibleIndex: index
          }]
        });

        await axios.put(`${POS_API}/product/v2`, {
          modifierId: posShopId,
          modifierType: 1,
          productId: posMenuId,
          exposureSequence: index
        });
      })
    );

    document.location.reload();
  }
};

// 메뉴 순서 변경
export const bestMenuListChange = async (shopId, data) => {
  if (data.length > 0) {
    await Promise.all(
      data.map(async (value) => {
        await axios.post(`${ORDER_API}/menu/v2`, {
          shopId: shopId,
          setMenuList: [{
            menuId: value.menuId,
            mainMenuVisibleIndex: value.mainMenuVisibleIndex
          }]
        });
      })
    );
  }
};

// 그룹/메뉴 삭제
export const deleteMenu = async (shopId, removeGrpList, removeMenuList) => {
  const posShopId = await shopMapping(shopId);

  // 메뉴 삭제
  if(removeMenuList.length > 0) {
    await Promise.all(
      removeMenuList.map(async ({grpId, menuId}) => {
        const posMenuId = await menuMapping(menuId);
        await deleteOrderMenu(shopId, grpId, menuId);
        await deletePosMenu(posShopId, posMenuId);
      })
    )
  }
  if(removeGrpList.length > 0) {
    await Promise.all(
      removeGrpList.map(async (value) => {
        const posGrpId = await menuGrpMapping(value);

        await deleteOrderMenuGrp(shopId, value);
        await deletePosMenuGrp(posShopId, posGrpId);
      })
    )
  }

  window.location.reload();
}

// 주문 채널 그룹 삭제
export const deleteOrderMenuGrp = async (shopId, groId) => {
  await axios.post(`${ORDER_API}/menu/v2/group`, {
    shopId: shopId,
    removeMenuGroupIdList: [groId]
  })
}

// 주문 채널 메뉴 삭제
export const deleteOrderMenu = async (shopId, grpId, menuId) => {
  await axios.post(`${ORDER_API}/menu/v2`, {
    shopId: shopId,
    menuGroupId: grpId,
    removeMenuIdList: [menuId]
  })
}

// 포스 채널 그룹 삭제
export const deletePosMenuGrp = async (shopId, grpId) => {
  await axios.delete((`${POS_API}/product/v2/group`), {
    params: {
      modifierId: shopId,
      modifierType: 1,
      itemIdList: grpId
    }
  });
}

// 포스 채널 메뉴 삭제
export const deletePosMenu = async (shopId, menuId) => {
  await axios.delete((`${POS_API}/product/v2`), {
    params: {
      modifierId: shopId,
      modifierType: 1,
      itemIdList: menuId
    }
  });
}